import { gql } from '@apollo/client/core'

const ONE_TIME_PAYMENT_CHECKOUT = gql`
  query oneTimePaymentCheckout($id: ID!) {
    oneTimePaymentCheckout(id: $id) {
      id
      state
      invoice {
        id
        stripeId
        total
        status
        primaryProduct {
          id
          key
          title
        }
      }
    }
  }
`

export default ONE_TIME_PAYMENT_CHECKOUT
